$( () => {
  const filterSection = $( '.bs-section--post-integrations' );
  if ( filterSection.length === 0 ) return;
  const popupButton = filterSection.find( '.bs-pro-button' );
  const div = popupButton.parents( '.bs-div' );
  const expandDuration = 600;

  const searchAndButtonWrap = () => {
    div.find( '.facetwp-facet-search, .bs-pro-button' ).wrapAll( '<div class="bs-div__popup-wrap"></div>' );
  };

  const filterOptionsWrap = () => {
    div
      .find( '.facet-checkbox-select-all, .facetwp-type-checkboxes, .facetwp-reset-button' )
      .wrapAll( '<div class="bs-div__filter-option-wrap"></div>' );
  };

  searchAndButtonWrap();
  filterOptionsWrap();

  const filterDropdown = filterSection.find( '.bs-div__filter-option-wrap' );

  popupButton.on( 'click', () => {
    const isOpen = div.hasClass( 'button-open' );
    if ( isOpen ) {
      div.removeClass( 'button-open' );
      filterDropdown.slideUp( expandDuration );
    } else {
      div.addClass( 'button-open' );
      filterDropdown.slideDown( expandDuration );
    }
  } );


} );
